import { Typography } from "@mui/material";
import { makeStyles } from "@/compat/muiStyles";
import { green } from "@mui/material/colors";

const PARTIAL_COLOUR = "#e0a12f";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    minWidth: 120,
  },
  track: {
    flex: 1,
    maxWidth: 100,
    height: 8,
    borderRadius: 4,
    backgroundColor: theme.palette.grey[200],
    overflow: "hidden",
  },
  fill: {
    height: "100%",
    borderRadius: 4,
  },
  count: { whiteSpace: "nowrap" },
  muted: { color: theme.palette.text.secondary },
}));

// Acknowledged / total acknowledgement progress bar (presentational).
export default function RiskAssessmentSharingProgress({
  acknowledged,
  total,
  loading,
}: {
  acknowledged: number;
  total: number;
  loading?: boolean;
}) {
  const classes = useStyles();

  if (loading)
    return (
      <div className={classes.wrapper}>
        <Typography variant="caption" className={classes.muted}>
          …
        </Typography>
      </div>
    );

  if (!total)
    return (
      <div className={classes.wrapper}>
        <Typography variant="caption" className={classes.muted}>
          Not shared
        </Typography>
      </div>
    );

  const percent = Math.round((acknowledged / total) * 100);
  const complete = acknowledged === total;

  return (
    <div className={classes.wrapper}>
      <div className={classes.track}>
        <div className={classes.fill} style={{ width: `${percent}%`, backgroundColor: complete ? green[500] : PARTIAL_COLOUR }} />
      </div>
      <Typography variant="body2" className={classes.count}>
        {acknowledged}/{total}
      </Typography>
    </div>
  );
}
